import React, { useEffect, useState } from 'react'

export default function useForm(initialFormValues, validateOnChange = false, validate) {

    
    const [formValues, setFormValues] = useState({});
    const [errors, setErrors] = useState({});

    useEffect(()=>{
        setFormValues(initialFormValues);
    },[initialFormValues])

    const handleOnChange = e => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value
        });
        // if (validateOnChange) validate({ [name]: value })
    }

    const resetForm = () => {
        setFormValues(initialFormValues);
        setErrors({});
    }
    return {
        formValues,
        setFormValues,
        handleOnChange,
        errors,
        setErrors,
        resetForm
    }
}
